import { Injectable } from '@angular/core';
import razorAnalytics from '@razorpay/razor-analytics';
import razorAnalyticsPlugins from '@razorpay/razor-analytics-plugins';
import { environment } from 'projects/visa-platform/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RazorpayAnalyticsService {
  public env = environment;
  private isInitialized = false;

  public constructor() {
    if (environment.production) {
      this.init();
    }
  }

  public init(): void {
    const { lumberjack } = razorAnalyticsPlugins;
    if (this.isInitialized) {
      console.warn('Razorpay Analytics is already initialized');
      return;
    }

    if (typeof window === 'undefined') {
      console.warn(
        'Razorpay Analytics can only be initialized in browser environment'
      );
      return;
    }

    razorAnalytics.init({
      plugins: [
        lumberjack({
          environment: 'production',
          transportConfig: {
            key: 'NzA1YmYxZjVkYjA0NzY1ZmQzZDA4NzI5',
            appName: 'engage-frontend-network-program',
            url: 'https://lumberjack.razorpay.com/v1/track',
          },
        }),
        // TODO: Add segment once segment setup is done
      ],
      // TODO: Change to live once basic sanity checks are done
      mode: environment.production ? 'live' : 'debug',
      pageConfig: {
        captureSearchParams: true,
      },
      autoCapture: {
        enabled: true,
        buttonClick: {
          enabled: true,
          captureTextContent: true,
        },
        formSubmit: {
          enabled: true,
        },
        inputChange: {
          enabled: true,
          captureInputValue: true,
        },
        inputError: {
          enabled: true,
        },
        linkClick: {
          enabled: true,
          captureTextContent: true,
        },
      },
    });

    this.isInitialized = true;
  }

  public setIdentity(userId: string, traits?: Record<string, string>): void {
    if (!this.isInitialized) {
      console.warn('Razorpay Analytics is not initialized');
      return;
    }
    razorAnalytics.setIdentity(userId, traits || {});
  }

  /**
   * Remove user identity
   */
  public removeIdentity(): void {
    if (!this.isInitialized) {
      console.warn('Razorpay Analytics is not initialized');
      return;
    }
    razorAnalytics.removeIdentity();
  }

  public debug(enabled: boolean): void {
    if (!this.isInitialized) {
      console.warn('Razorpay Analytics is not initialized');
      return;
    }
    razorAnalytics.debug(enabled);
  }

  public milestoneEvent(eventData: {
    eventName: string;
    attributes?: Record<string, unknown>;
  }): void {
    if (!this.isInitialized) {
      console.warn('Razorpay Analytics is not initialized');
      return;
    }
    razorAnalytics.trackMilestoneEvent(eventData);
  }

  public stepEvent(eventData: {
    eventName: string;
    attributes?: Record<string, unknown>;
  }): void {
    if (!this.isInitialized) {
      console.warn('Razorpay Analytics is not initialized');
      return;
    }
    razorAnalytics.trackStepEvent(eventData);
  }
}
